// removed by extract-text-webpack-plugin
module.exports = {"loaderText":"loaderText__zWl3d","mdc-dialog--open":"mdc-dialog--open__tYYNH","mdc-dialog__backdrop":"mdc-dialog__backdrop__3Ppnd"};


//////////////////
// WEBPACK FOOTER
// ./components/loader/loader.css
// module id = FgT3
// module chunks = 308 317 321 322 325 326 329 340 357